export class SedesTramitesUACPK {
    public idTramite: string;
    public sede: string;
}

export class SedesTramitesUAC {
    public sedesTramitesUACPK: SedesTramitesUACPK;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
    public isDelete: string;
    public isDefault: string;

}